import { NgModule } from '@angular/core'
import { RecurrentNeighborhoodsResultComponent } from './recurrent-neighborhoods-result/recurrent-neighborhoods-result.component'
import { RecurrentNeighborhoodsResultContent } from './recurrent-neighborhoods-result/recurrent-neighborhoods-result-content/recurrent-neighborhoods-result-content.component'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { UiLibraryModule } from '../ui-library/ui-library.module'
import { LetModule } from '@ngrx/component'
import { SharedModule } from '../shared/shared.module'
import { SelectionModule } from '../selection/selection.module'
import { NeighborhoodEnrichmentResultComponent } from './neighborhood-enrichment-result/neighborhood-enrichment-result.component'
import { NeighborhoodEnrichmentResultContent } from './neighborhood-enrichment-result/neighborhood-enrichment-result-content/neighborhood-enrichment-result-content.component'
import { CellTypeDetectionResultComponent } from './cell-type-detection-result/cell-type-detection-result.component'
import { CellTypeDetectionResultContent } from './cell-type-detection-result/cell-type-detection-result-content/cell-type-detection-result-content.component'

@NgModule({
    declarations: [
        RecurrentNeighborhoodsResultComponent,
        RecurrentNeighborhoodsResultContent,
        NeighborhoodEnrichmentResultComponent,
        NeighborhoodEnrichmentResultContent,
        CellTypeDetectionResultComponent,
        CellTypeDetectionResultContent,
    ],
    exports: [
        RecurrentNeighborhoodsResultComponent,
        NeighborhoodEnrichmentResultComponent,
        CellTypeDetectionResultComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        UiLibraryModule,
        LetModule,
        SharedModule,
        SelectionModule,
        ReactiveFormsModule,
    ],
})
export class ResultsModule {}
